(function(){
  // reveal on scroll
  var obs=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-visible');obs.unobserve(e.target);}});},{threshold:.12});
  function bindReveal(){document.querySelectorAll('.reveal:not(.is-visible)').forEach(function(el){obs.observe(el);});}
  document.addEventListener('DOMContentLoaded',bindReveal);

  // header shadow on scroll
  var header=document.querySelector('.site-header');
  window.addEventListener('scroll',function(){if(!header)return;header.classList.toggle('scrolled',window.scrollY>20);});

  // mobile drawer
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-drawer-open]')){document.querySelector('.drawer').classList.add('open');document.querySelector('.overlay').classList.add('open');}
    if(e.target.closest('[data-drawer-close]')||e.target.classList.contains('overlay')){document.querySelector('.drawer').classList.remove('open');document.querySelector('.overlay').classList.remove('open');}
  });

  // accordion
  document.addEventListener('click',function(e){
    var h=e.target.closest('.accordion__head');if(!h)return;
    var item=h.parentElement;var body=item.querySelector('.accordion__body');
    var open=item.classList.toggle('open');
    body.style.maxHeight=open?body.scrollHeight+'px':null;
  });

  // product gallery
  document.addEventListener('click',function(e){
    var t=e.target.closest('.gallery__thumbs button');if(!t)return;
    var main=document.querySelector('.gallery__main img');
    if(main){main.src=t.getAttribute('data-full');main.srcset='';}
    document.querySelectorAll('.gallery__thumbs button').forEach(function(b){b.classList.remove('active');});
    t.classList.add('active');
  });

  // quantity
  document.addEventListener('click',function(e){
    var b=e.target.closest('.qty button');if(!b)return;
    var input=b.parentElement.querySelector('input');var v=parseInt(input.value||'1',10);
    if(b.dataset.dir==='up')v++;else v=Math.max(1,v-1);input.value=v;
  });

  // variant selector -> price + hidden id
  var pform=document.querySelector('[data-product-form]');
  if(pform){
    var data=document.getElementById('variant-json');
    if(data){
      try{var variants=JSON.parse(data.textContent);}catch(err){variants=[];}
      function money(c){return 'R$ '+(c/100).toFixed(2).replace('.',',');}
      function update(){
        var sels=pform.querySelectorAll('[data-opt]');var chosen=[];
        sels.forEach(function(s){chosen.push(s.value);});
        var match=variants.find(function(v){return v.options.join(' / ')===chosen.join(' / ');})||variants[0];
        if(!match)return;
        pform.querySelector('[name="id"]').value=match.id;
        var pr=document.querySelector('[data-price]');if(pr)pr.textContent=money(match.price);
        var btn=pform.querySelector('[data-add]');var stock=document.querySelector('[data-stock]');
        if(match.available){if(btn){btn.disabled=false;btn.textContent='Comprar agora';}if(stock){stock.textContent='Em estoque · pronto para seleção';stock.classList.remove('out');}}
        else{if(btn){btn.disabled=true;btn.textContent='Esgotado';}if(stock){stock.textContent='Indisponível no momento';stock.classList.add('out');}}
      }
      pform.querySelectorAll('[data-opt]').forEach(function(s){s.addEventListener('change',update);});
      update();
    }
  }
})();
